import { render, staticRenderFns } from "./CreateTagForm.vue?vue&type=template&id=e0820cfa&scoped=true"
import script from "./CreateTagForm.vue?vue&type=script&lang=js"
export * from "./CreateTagForm.vue?vue&type=script&lang=js"
import style0 from "./CreateTagForm.vue?vue&type=style&index=0&id=e0820cfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0820cfa",
  null
  
)

export default component.exports